(() => {
  /* Code to close the Announcement bar */
  const selectors = {
    toolBar: "#shopify-section-toolbar",
    closeToolbar: "[data-toolbar-close]",
  };
  const $toolbar = document.querySelector(selectors.toolBar);
  const $closeToolbar = document.querySelector(selectors.closeToolbar);

  const setCookie = ({ key, value, days }) => {
    document.cookie = `${key}=${value}; path=/; max-age=${
      60 * 60 * 24 * days
    };`;
  };
  const getCookie = ({ key }) => {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${key}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };
  if (getCookie({ key: "closeToolbar" })) {
    $toolbar.classList.add("hidden");
  }

  const hideToolbar = () => {
    $toolbar.classList.add("hidden");
    setCookie({ key: "closeToolbar", value: "closed", days: 14 });
  };
  $closeToolbar.addEventListener("click", hideToolbar);
  /* Code to toggle accordion menu wrappers for mobile version  */
  const mobileAccordionMenuSelectors = {
    accordion: ".hc-accordion",
    active: "hc-active",
  };
  const handleButton = (evt) => {
    evt.target.classList.toggle(mobileAccordionMenuSelectors.active);
    let panel = evt.target.nextElementSibling;
    panel.classList.toggle("hc-visible");
    panel.style.maxHeight = panel.style.maxHeight ? null : `100%`;
  };
  const $accordionButtons = document.querySelectorAll(
    mobileAccordionMenuSelectors.accordion
  );
  $accordionButtons.forEach(($accordion) => {
    $accordion.addEventListener("click", handleButton);
  });
  /* HC Code to open the default cart drawer by clicking the cart icon on mobile */
  const cartSelectors = {
    main_cart: "#HeaderCartTrigger",
    mobile_cart: "#HeaderCartTriggerAlt",
  };
  const $mainCartSelector = document.querySelector(cartSelectors.main_cart);
  const $mobileCartSelector = document.querySelector(cartSelectors.mobile_cart);

  $mobileCartSelector.addEventListener("click", (evt) => {
    evt.preventDefault();
    $mainCartSelector.click();
  });
  /* HC Code to handle the custom quantities selectors */
  const quantitySelectors = {
    decrease: ".hc-quantity-wrapper .btn-decrease",
    increase: ".hc-quantity-wrapper .btn-increase",
  };

  // Handle decrease quantity button
  document.querySelectorEver(quantitySelectors.decrease, (el) => {
    el.addEventListener("click", function () {
      let input = this.parentNode.querySelector('[name="quantity"]');
      let step = Number(input.step) || 1;
      let min = Number(input.min) || 1;
      let value = Number(input.value) || min;
      // Decrease, but never below the minimum
      input.value = Math.max(value - step, min);
      // Trigger the change event so other logic/listeners update accordingly
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  // Handle increase quantity button
  document.querySelectorEver(quantitySelectors.increase, (el) => {
    el.addEventListener("click", function () {
      let input = this.parentNode.querySelector('[name="quantity"]');
      let step = Number(input.step) || 1;
      let max = Number(input.max) || Infinity;
      let value = Number(input.value) || 1;
      // Increase, but never above the maximum (if defined)
      input.value = Math.min(value + step, max);
      // Trigger the change event so other logic/listeners update accordingly
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  // Handle manual input or any programmatic change
  document.querySelectorEver(".hc-quantity-wrapper [name='quantity']", (el) => {
    el.addEventListener("change", function () {
      let step = Number(this.step) || 1;
      let min = Number(this.min) || 1;
      let max = Number(this.max) || Infinity;
      let value = Math.round(Number(this.value)) || min;
      // Clamp value within min and max
      value = Math.max(min, Math.min(value, max));
      // Adjust value to the nearest multiple of step
      if (value % step !== 0) {
        value = Math.round(value / step) * step;
      }
      this.value = value;
    });
  });

  /* HC Code to add the product to cart from product grid item via AJAX */
  const miniForms = {
    form: ".hc-mini-cart",
  };
  const AddToCart = ({ items }) => {
    return fetch(theme.routes.cartAdd, {
      method: "POST",
      body: JSON.stringify(items),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => response.json());
  };
  const success = (product, ATCButton) => {
    ATCButton.classList.remove("btn--loading");
    document.dispatchEvent(
      new CustomEvent("ajaxProduct:added", {
        detail: {
          product: product,
          addToCartBtn: ATCButton,
        },
      })
    );
  };
  const handleSubmit = (evt) => {
    evt.preventDefault();
    const $form = evt.target;
    const formData = new FormData($form);
    const id = formData.get("id");
    const quantity = formData.get("quantity");
    const items = { id, quantity };
    const ATCButton = $form.querySelector(".add-to-cart");
    ATCButton.classList.add("btn--loading");
    AddToCart({ items }).then((product) => success(product, ATCButton));
  };
  document.querySelectorEver(miniForms.form, (el) => {
    el.addEventListener("submit", handleSubmit);
  });
  /* HC code to handle the 2nd menu on the mobile version */
  const altMenuSelectors = {
    nav: "#second.slide-nav",
    allLinks: "a.slide-nav__link",
    subNavToggleBtn: ".js-toggle-submenu",
    menuLevel: 1,
    childList: ".slide-nav__dropdown",
    isActive: "is-active",
    wrapper: ".slide-nav__wrapper",
  };
  const altMenuConfig = {};

  const setWrapperHeight = (wrapper, height) => {
    wrapper.style.height = `${height}px`;
  };
  const toggleMenu = (target, $altNav, altWrapper, targetMenu) => {
    if (targetMenu) {
      altMenuConfig.menuLevel = targetMenu.dataset.level;
      if (altMenuConfig.menuLevel == 2) {
        $altNav
          .querySelectorAll(`${altMenuSelectors.childList} [data-level="3"]`)
          .forEach((list) => {
            list.classList.remove(altMenuSelectors.isActive);
          });
      }
      targetMenu.classList.add(altMenuSelectors.isActive);
      setWrapperHeight(altWrapper, targetMenu.offsetHeight);
    } else {
      altMenuConfig.menuLevel = 1;
      altWrapper.removeAttribute("style");
      $altNav.querySelectorAll(altMenuSelectors.childList).forEach((list) => {
        list.classList.remove(altMenuSelectors.isActive);
      });
    }
  };
  const $altNav = document.querySelector(altMenuSelectors.nav) || null;
  if ($altNav) {
    const altWrapper = $altNav.closest(altMenuSelectors.wrapper);
    $altNav
      .querySelectorAll(altMenuSelectors.subNavToggleBtn)
      .forEach((btn) => {
        btn.addEventListener("click", function () {
          let { target } = btn.dataset;
          var targetMenu = document.querySelector(`[data-parent="${target}"]`);
          toggleMenu(target, $altNav, altWrapper, targetMenu);
          altWrapper.dataset.level = altMenuConfig.menuLevel;
        });
      });
  }
  /* HC code to add the Read more on the collection description page */
  const collectionSelectors = {
    wrapper: ".rte--collection-desc .enlarge-text",
  };
  $readMoreJS.init({
    target: collectionSelectors.wrapper, // Selector of the element the plugin applies to (any CSS selector, eg: '#', '.'). Default: ''
    numOfWords: 50, // Number of words to initially display (any number). Default: 50
    toggle: true, // If true, user can toggle between 'read more' and 'read less'. Default: true
    moreLink: theme.strings.readMore, // The text of 'Read more' link. Default: 'read more ...'
    lessLink: theme.strings.readLess, // The text of 'Read less' link. Default: 'read less'
  });

  /* const $collectionDescriptionWrapper =
    document.querySelector(collectionSelectors.wrapper) || null;
    if ($collectionDescriptionWrapper) {
            const DEFAULT_HEIGHT = 120;
            if ($collectionDescriptionWrapper.offsetHeight > DEFAULT_HEIGHT) {
                const readMore = new ReadMore({
                    height: `${DEFAULT_HEIGHT}px`,
                    wrapper: collectionSelectors.wrapper,
                    readMore: theme.strings.readMore,
                    readLess: theme.strings.readLess
                })
            }
    }*/
  /* HC Adding re buy feature account orders */
  /*
  const rebuySelectors = {
    buttons: ".hc-rebuy",
    headerCartTrigger: "#HeaderCartTrigger",
  };
  const $rebuyButtons =
    document.querySelectorAll(rebuySelectors.buttons) || null;
  if ($rebuyButtons) {
    $rebuyButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const { url } = this.dataset;
        fetch(`${url}?view=ajax`)
          .then((res) => res.json())
          .then((items) => AddToCart({ items }))
          .then((res) => {
            document.dispatchEvent(new CustomEvent("cart:build"));
            document.querySelector("#HeaderCartTrigger").click();
          });
      });
    });
  }
  */

  const rebuySelectors = {
    buttons: ".hc-rebuy",
    headerCartTrigger: "#HeaderCartTrigger",
  };

  const $rebuyButtons = document.querySelectorAll(rebuySelectors.buttons) || null;

  if ($rebuyButtons) {
    $rebuyButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const { url } = this.dataset;
        
        fetch(`${url}?view=ajax`)
          .then((res) => res.json())
          .then(async (data) => {
            console.log('Raw data received:', data);
            
            // Handle different response formats
            let items = [];
            if (Array.isArray(data)) {
              items = data;
            } else if (data.items && Array.isArray(data.items)) {
              items = data.items;
            } else if (data.line_items && Array.isArray(data.line_items)) {
              items = data.line_items;
            } else {
              console.error('Unexpected data format:', data);
              throw new Error('Invalid items format');
            }
            
            console.log('Items to process:', items);
            
            // Verify and replace unavailable items
            const verifiedItems = await verifyAndReplaceItems(items);
            console.log('Verified items:', verifiedItems);
            
            // Add items to cart one by one or in batch
            return addItemsToCart(verifiedItems);
          })
          .then((res) => {
            console.log('Items added to cart successfully');
            document.dispatchEvent(new CustomEvent("cart:build"));
            document.querySelector("#HeaderCartTrigger").click();
          })
          .catch((error) => {
            console.error("Error processing reorder:", error);
            alert('There was an error processing your reorder. Please try again.');
          });
      });
    });
  }

  /**
   * Add items to cart with proper error handling
   */
  async function addItemsToCart(items) {
    if (!items || items.length === 0) {
      throw new Error('No items to add to cart');
    }
    
    try {
      // Use the batch add endpoint
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items })
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Cart add failed:', errorText);
        throw new Error(`Failed to add items to cart: ${response.status}`);
      }
      
      // Check if response has content
      const text = await response.text();
      if (text) {
        return JSON.parse(text);
      }
      
      return { success: true };
    } catch (error) {
      console.error('Error adding items to cart:', error);
      throw error;
    }
  }

  /**
   * Verify items availability and replace with products that have the same SKU
   */
  async function verifyAndReplaceItems(items) {
    if (!Array.isArray(items)) {
      console.error('Items is not an array:', items);
      return [];
    }
    
    const verifiedItems = [];
    
    for (const item of items) {
      try {
        // Get variant ID
        const variantId = item.variant_id || item.id;
        
        // Check if variant is available
        const variantCheck = await fetch(`/variants/${variantId}.js`);
        
        if (variantCheck.ok) {
          const variant = await variantCheck.json();
          
          // If variant is available, add it
          if (variant.available) {
            verifiedItems.push({
              id: variantId,
              quantity: item.quantity || 1
            });
            console.log(`✅ Variant ${variantId} is available`);
          } else {
            // Variant not available, search by SKU
            console.log(`⚠️ Variant ${variantId} not available, searching by SKU: ${variant.sku}`);
            
            const replacementVariant = await findVariantBySKU(variant.sku);
            
            if (replacementVariant) {
              console.log(`✅ Found replacement variant ${replacementVariant.id} for SKU ${variant.sku}`);
              verifiedItems.push({
                id: replacementVariant.id,
                quantity: item.quantity || 1
              });
            } else {
              console.warn(`❌ No replacement found for SKU: ${variant.sku}`);
            }
          }
        } else {
          console.error(`❌ Variant ${variantId} not found`);
          
          // Try to find by SKU if we have it
          const sku = item.sku;
          if (sku) {
            console.log(`🔍 Searching by SKU: ${sku}`);
            const replacementVariant = await findVariantBySKU(sku);
            
            if (replacementVariant) {
              verifiedItems.push({
                id: replacementVariant.id,
                quantity: item.quantity || 1
              });
            }
          }
        }
      } catch (error) {
        console.error(`Error verifying item:`, error);
      }
    }
    
    return verifiedItems;
  }

  /**
   * Search for a variant by SKU
   */
  async function findVariantBySKU(sku) {
    if (!sku) return null;
    
    try {
      // Try search endpoint
      const searchResponse = await fetch(`/search/suggest.json?q=${sku}&resources[type]=product&resources[limit]=10`);
      
      if (!searchResponse.ok) {
        console.error('Search failed:', searchResponse.status);
        return null;
      }
      
      const searchData = await searchResponse.json();
      
      if (searchData.resources && searchData.resources.results && searchData.resources.results.products) {
        const products = searchData.resources.results.products;
        
        // Search through products for matching SKU
        for (const product of products) {
          // Fetch full product data
          const productResponse = await fetch(`/products/${product.handle}.js`);
          
          if (productResponse.ok) {
            const productData = await productResponse.json();
            
            const matchingVariant = productData.variants.find(
              v => v.sku === sku && v.available
            );
            
            if (matchingVariant) {
              return matchingVariant;
            }
          }
        }
      }
      
      return null;
    } catch (error) {
      console.error(`Error searching for SKU ${sku}:`, error);
      return null;
    }
  }
  // END - Adding re buy feature account orders

  const klaviyoFormsSelectors = {
    formSelectors: "[data-form-klaviyo]",
  };
  const $klaviyoForms =
    document.querySelectorAll(klaviyoFormsSelectors.formSelectors) || null;
  if ($klaviyoForms) {
    $klaviyoForms.forEach(($form) => {
      let $formData = new FormData($form);
      KlaviyoSubscribe.attachToForms(`#${$form.id}`, {
        hide_form_on_success: true,
        custom_success_message: true,
        success: function ($formElement) {
          var email = $formData.get("email");
          _learnq.push(["identify", { $email: email }]);
          _learnq.push(["track", "Signed Up for Newsletter"]);
          console.log($formElement);
          $form.style.display = "none";
        },
      });
    });
  }
  const downloadButtonsSelectors = {
    downloadButton: ".hc-download-button",
  };
  const $downloadButtons =
    document.querySelectorAll(downloadButtonsSelectors.downloadButton) || null;
  if ($downloadButtons) {
    $downloadButtons.forEach(($button) => {
      const url = $button.href;
      $button.addEventListener("click", (e) => {
        if ($button.dataset.canDownload !== "true") {
          e.preventDefault();
          $button.dataset.queueDownload = "true";
        }
      });
      fetch(url, {
        headers: new Headers({
          Origin: location.origin,
        }),
        mode: "cors",
      })
        .then((response) => response.blob())
        .then((blob) => {
          let blobUrl = window.URL.createObjectURL(blob);
          $button.setAttribute("href", blobUrl);
          $button.dataset.canDownload = "true";
          if ($button.dataset.queueDownload == "true") {
            $button.click();
            $button.datest.queueDownload = "false";
          }
        });
    });
  }
  const warningPopupSelectors = {
    modal: "#myModal",
    enterButton: ".btn--enter",
  };
  const $modal = document.querySelector(warningPopupSelectors.modal) || null;
  if ($modal) {
    $buttonEnter = $modal.querySelector(warningPopupSelectors.enterButton);
    if (!sessionStorage["disableExitIntent"]) {
      $modal.style.display = "block";
    }
    $buttonEnter.addEventListener("click", function (e) {
      e.preventDefault();
      sessionStorage["disableExitIntent"] = true;
      $modal.style.display = "none";
    });
  }
})();
